function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { createRef, useMemo, useRef } from "react";
import { useUIDSeed } from "react-uid";
import { useSectionNavigation } from "../../../hooks/useSectionNavigation";
import { Heading, Subheading } from "../../atoms";
import { IconInfoListItem, NavigationList, Section } from "../../molecules";
export var IconInfoList = function(param) {
    var label = param.label, title = param.title, items = param.items, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    var containerRef = useRef(null);
    var indexInView = useSectionNavigation(containerRef, ":scope > div");
    var itemRefs = useMemo(function() {
        return items.map(function() {
            return /*#__PURE__*/ createRef();
        });
    }, [
        items
    ]);
    var mappedItems = useMemo(function() {
        return items.map(function(item, index) {
            return {
                active: index === indexInView,
                label: item.title,
                onClick: function() {
                    var ref = itemRefs[index];
                    if (ref.current) {
                        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                        var rect = ref.current.getBoundingClientRect();
                        window.scrollTo({
                            top: scrollTop + rect.top - 100,
                            behavior: "smooth"
                        });
                    }
                }
            };
        });
    }, [
        items,
        indexInView
    ]);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-8 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "md:sticky md:top-[2rem]"
    }, !label && /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: "block pointer-events-none mb-4 border-b-2 border-fg-default w-[6.25rem]"
    }), !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: ""
    }, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h3",
        className: ""
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "-ml-4 md:-ml-5"
    }, /*#__PURE__*/ React.createElement(NavigationList, {
        variant: "sections",
        className: "mt-7 md:mt-8",
        items: mappedItems
    })))), /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-8"
    }, items.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(item),
            ref: itemRefs[index]
        }, /*#__PURE__*/ React.createElement(IconInfoListItem, _extends({}, item)));
    }))));
};

//# sourceMappingURL=IconInfoList.js.map